import React, { useContext, useEffect, useState } from "react";
import { showError } from "../utils/toastUtils";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import SubmitButton from "../components/partials/global/SubmitButton";
import AuthAPI from "../api/authApi";
import { setAccessToken } from "../api/axiosInstance";
import { handleApiValidationError } from "../utils/apiErrorHandler";
import StoreAPI from "../api/StoreApi";
import { UserContext } from "../utils/UserContext";
import { shouldFetchStoreDetails } from "../utils/domainUtils";

const Login = () => {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [autoFilled, setAutoFilled] = useState(false);
  const { setUser } = useContext(UserContext);

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [mainLogo, setMainLogo] = useState("");

  useEffect(() => {
    if (shouldFetchStoreDetails()) {
      fetchMyDetailsUsingDomain();
    }

    const savedEmail = Cookies.get("rememberEmail");
    const savedPassword = Cookies.get("rememberPassword");

    if (savedEmail && savedPassword) {
      setEmail(savedEmail);
      setPassword(savedPassword);
      setRemember(true);
      setAutoFilled(true);
    }
  }, []);

  const fetchMyDetailsUsingDomain = async () => {
    const url = window.location.href;

    try {
      const res = await StoreAPI.getDetailsUsingDomain({ url });

      if (res.code === 200) {
        const result = res.data;

        document.title = result.name;
        setTitle(result.name);
        setMainLogo(result.logo);
        setFavicon(result.favicon);
      }
    } catch (err) {}
  };

  function setFavicon(url) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href = url;
  }

  const validate = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const newErrors = {};
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email";
    }

    if (!password) {
      newErrors.password = "Password is required";
    } else if (password.length < 6) {
      newErrors.password =
        "Password length must be equal or greater than 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    if (!validate()) {
      setIsLoading(false);
      return;
    }

    try {
      const res = await AuthAPI.login({ email, password });

      if (res.code === 200) {
        setAccessToken(res.data.access_token);

        // User state update karo
        const user = {
          name: res.data.name,
          email: res.data.email,
          roles: res.data.role,
          image: res.data.image,
          permissions: res.data?.permissions,
          username: res.data.username || "",
          logo: res.data?.store?.logo || "",
          storeName: res.data?.store?.name || "",
          storeId: res.data?.store?.id || "",
          websiteUrl: res.data?.store?.websiteUrl || "",
        };

        localStorage.setItem("user", JSON.stringify(user));
        setUser(user);
        navigate("/dashboard");
      } else {
        showError(res.message);
      }
    } catch (err) {
      handleApiValidationError(err, setErrors);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="account-content">
          <div className="row login-wrapper m-0">
            <div className="col-lg-6 p-0">
              <div className="login-content">
                <form method="post" onSubmit={handleSubmit}>
                  <div className="login-userset">
                    <div className="login-logo logo-normal">
                      <img
                        src={
                          mainLogo || `${process.env.PUBLIC_URL}/img/logo.png`
                        }
                        alt="img"
                      />
                    </div>
                    <Link className="login-logo logo-white">
                      <img
                        src={
                          mainLogo || `${process.env.PUBLIC_URL}/img/logo.png`
                        }
                        alt="Img"
                      />
                    </Link>
                    <div className="login-userheading">
                      <h3>Sign In</h3>
                      <h4>
                        Access the {title || "Super"} Admin panel using your
                        email and password.
                      </h4>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        Email Address
                        <span className="required-indicator">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          type="email"
                          placeholder="Enter Email Address"
                          autoComplete="email"
                          className={`form-control border-end-0 ${
                            autoFilled ? "autofilled" : ""
                          }`}
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                        <span className="input-group-text border-start-0">
                          <i className="ti ti-mail" />
                        </span>
                      </div>
                      {errors.email && (
                        <span className="errors text-danger">
                          {errors.email}
                        </span>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        Password <span className="required-indicator">*</span>
                      </label>
                      <div className="pass-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter Password"
                          className={`form-control ${
                            autoFilled ? "autofilled" : ""
                          }`}
                          autoComplete="new-password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <span
                          onClick={() => setShowPassword(!showPassword)}
                          className="ti toggle-password ti-eye-off text-gray-9"
                        />
                      </div>
                      {errors.password && (
                        <span className="errors text-danger">
                          {errors.password}
                        </span>
                      )}
                    </div>
                    <div className="form-login authentication-check">
                      <div className="row">
                        <div className="col-6">
                          <div className="custom-control custom-checkbox">
                            <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                              <input
                                type="checkbox"
                                checked={remember}
                                onChange={(e) => setRemember(e.target.checked)}
                              />
                              <span className="checkmarks" />
                              Remember me
                            </label>
                          </div>
                        </div>
                        <div className="col-6 text-end">
                          <Link to="/forgot-password" className="forgot-link">
                            Forgot Password?
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="form-login">
                      <SubmitButton
                        isLoading={isLoading}
                        text="Sign In"
                        loadingText="Signing In..."
                        className="w-100"
                      ></SubmitButton>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-6 p-0">
              <div className="login-img">
                <img
                  src={`${process.env.PUBLIC_URL}/img/authentication/login-page-image.png`}
                  alt="Img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
